export default {"src":"/_next/static/media/integration-ux-ui-objects.d2566200.svg","height":205,"width":480,"blurWidth":0,"blurHeight":0};